import { Spinner, Center, Button, Box, Text, Icon } from "@chakra-ui/react";
import { Drawer, DrawerOverlay, DrawerContent, DrawerHeader, DrawerBody } from "@chakra-ui/react";

import { FaRegCheckCircle } from "react-icons/fa";
import Confetti from "react-confetti"; // You may need to install this: npm install react-confetti

import React, { useContext, useState, useEffect } from "react";
import { Input, Image } from "@chakra-ui/react";
import axios from "axios";
import { RoomContext } from "../context/RoomContext";
import hotelImage from "../assets/img/gallSlider/20.png";  // Replace with your hotel image path
import { Link, useNavigate } from 'react-router-dom';
import { Link as ChakraLink } from "@chakra-ui/react";
import { FaStar } from "react-icons/fa";
import { COUNTRIES, INDIAN_CITIES, fetchLocationByPinCode } from "../utils/locationUtils";
import API_BASE_URL from "../api";

const CustomerDetails = () => {
  const { selectedRoomDetails } = useContext(RoomContext);
  const initialCustomerDetails = {
    firstName: "",
    lastName: "",
    companyName: "",
    phoneNumber: "",
    email: "",
    address: "",
    city: "",
    zipCode: "",
    country: "",
  };
  const [customerDetails, setCustomerDetails] = useState(initialCustomerDetails);
  const [orderId, setOrderId] = useState(null);
  const [totalAmount, setTotalAmount] = useState(0);
  const [isBookingInProgress, setIsBookingInProgress] = useState(false);
  const [isLookingUpLocation, setIsLookingUpLocation] = useState(false);

  const navigate = useNavigate();
  const [isBookingSuccess, setIsBookingSuccess] = useState(false);
  //const { isOpen, onOpen, onClose } = useDisclosure();
  useEffect(() => {
    if (isBookingSuccess) {
      setShowConfetti(true);
      const timer = setTimeout(() => {
        setShowConfetti(false);
        navigate('/');  // Redirect to homepage
      }, 2500);  // 2.5 seconds for confetti and modal

      return () => clearTimeout(timer);
    }
  }, [isBookingSuccess, navigate]);
  
  


  useEffect(() => {
    console.log("Loaded Selected Room Details:", selectedRoomDetails);
    
    if (selectedRoomDetails && !isNaN(selectedRoomDetails.totalAmount)) {
        setTotalAmount(selectedRoomDetails.totalAmount || 0);
    } else {
        console.warn("Invalid totalAmount detected", selectedRoomDetails);
    }
}, [selectedRoomDetails]);


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCustomerDetails((prevState) => ({ ...prevState, [name]: value }));
  };

  const handlePhoneChange = (e) => {
    const digitsOnly = e.target.value.replace(/\D/g, '').slice(0, 10);
    setCustomerDetails((prevState) => ({ ...prevState, phoneNumber: digitsOnly }));
  };

  const handleZipCodeChange = async (e) => {
    const digitsOnly = e.target.value.replace(/\D/g, '').slice(0, 6);
    setCustomerDetails((prevState) => ({ ...prevState, zipCode: digitsOnly }));

    if (digitsOnly.length === 6) {
      setIsLookingUpLocation(true);
      const location = await fetchLocationByPinCode(digitsOnly);
      setIsLookingUpLocation(false);

      if (location) {
        setCustomerDetails((prevState) => ({
          ...prevState,
          zipCode: digitsOnly,
          city: location.city,
          country: location.country,
        }));
      }
    }
  };

  const validateForm = () => {
    if (customerDetails.phoneNumber.length !== 10) {
      alert('Please enter a valid 10-digit phone number.');
      return false;
    }
    if (customerDetails.zipCode.length !== 6) {
      alert('Please enter a valid 6-digit pin code.');
      return false;
    }
    return true;
  };

  // Function to create an order ID
  const createOrderId = () => {
    const now = new Date();
    const formattedDate = now.toISOString().slice(0, 10).replace(/-/g, '');
    const formattedTime = now.toTimeString().slice(0, 8).replace(/:/g, '');
    const uniqueBookingId = `BK-${formattedDate}${formattedTime}-${Math.floor(Math.random() * 1000)}`;
    setOrderId(uniqueBookingId);
    return uniqueBookingId;
  };

  // Automatically generate order ID on component mount
  useEffect(() => {
    createOrderId();
  }, []);

  // Function for "Pay at Hotel" booking
  const handlePayAtHotel = async () => {
    if (isBookingInProgress) return;
    if (!validateForm()) return;
    setIsBookingInProgress(true);
         
    try {
      const bookingDetails = {
        customerDetails,
        roomId: selectedRoomDetails.roomId,
        checkInDate: selectedRoomDetails.checkInDate,
        checkOutDate: selectedRoomDetails.checkOutDate,
        roomType: selectedRoomDetails.roomType,
        adults: parseInt(selectedRoomDetails.adults) || 0,  // ✅ Convert to number
        kids: parseInt(selectedRoomDetails.kids) || 0,   
        amount: totalAmount,
        payment_method: "Pay at Hotel",
        mealPlan: 'CP',
        mealCost: 0,
        hotelName: selectedRoomDetails.selectedHotel,
      };
   
      
      const response = await axios.post(`${API_BASE_URL}/bookings`, bookingDetails);
      if (response.status === 201) {
        console.log("Booking successful with Pay at Hotel option:", response.data);
        setIsBookingSuccess(true);
        //onOpen();  // Open the modal for success message
      } else {
        console.error("Error creating booking with Pay at Hotel option:", response.data);
        alert("Failed to create booking. Please try again.");
      }
    } catch (error) {
      console.error("Error creating booking with Pay at Hotel option:", error);
      alert("An error occurred while booking. Please try again.");
    } finally {
      setIsBookingInProgress(false);
    }
  };
  
  // For confetti animation
  const [showConfetti, setShowConfetti] = useState(false);

  return (
    <div className="bg-gray-100 min-h-screen" style={{ backgroundColor: "#D5D5D5" }}>
      {/* Booking in progress overlay */}
      {isBookingInProgress && (
        <Box
          position="fixed"
          top={0}
          left={0}
          width="100vw"
          height="100vh"
          bg="rgba(0,0,0,0.5)"
          zIndex={2000}
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          style={{ backdropFilter: "blur(6px)" }}
        >
          <div className="booking-spinner-outer">
            <Spinner
              size="2xl"
              thickness="8px"
              speed="0.7s"
              color="blue.400"
              emptyColor="gray.200"
            />
          </div>
          <Text mt={6} fontSize="2xl" color="white" fontWeight="bold" letterSpacing="wide">
            Booking in progress...
          </Text>
        </Box>
      )}

      {/* Confetti animation on success */}
      {showConfetti && <Confetti width={window.innerWidth} height={window.innerHeight} />}

      {/* Success Modal */}
      <Drawer isOpen={isBookingSuccess} placement="bottom" onClose={() => setIsBookingSuccess(false)}>
        <DrawerOverlay />
        <DrawerContent
          className="animated-modal-content"
          maxW={["100vw", "400px", "500px", "600px"]}
          mx="auto"
          borderTopRadius="2xl"
          pb={8}
        >
          <DrawerHeader>
            <Center>
              <Icon
                as={FaRegCheckCircle}
                color="green.400"
                boxSize={[12, 14, 16, 20]}
                mb={2}
                style={{
                  filter: "drop-shadow(0 0 12px #34d399)",
                  animation: "pop-in 0.7s cubic-bezier(.68,-0.55,.27,1.55)"
                }}
              />
            </Center>
            <Text fontSize={["xl", "2xl", "2xl", "3xl"]} fontWeight="bold" color="green.500" mt={2}>
              Booking Confirmed!
            </Text>
          </DrawerHeader>
          <DrawerBody>
            <Text fontSize={["md", "lg"]} mb={2}>
              {customerDetails.email
                ? "Check your email for booking details."
                : "Your room is booked. We will contact you on your phone number."}
            </Text>
            <Text fontSize="md" color="gray.500">
              Thank you for booking with us!
            </Text>
          </DrawerBody>
        </DrawerContent>
      </Drawer>

      <div className="container mx-auto py-8 px-4">
        {/* Hotel Information Section */}
      
        <Box
          bg="#0C1938"
          p={4}
          rounded="lg"
          shadow="md"
          mb={8}
          display="flex"
          justifyContent="flex-start" // Left-aligns the content
          alignItems="center" // Centers the content vertically
          width="100%" // Covers the full width of the page
          minHeight="120px" // Adjust this value to increase the height of the box
        >
          <Text fontSize="28px" fontWeight="bold" color="white">
            Review your Booking
          </Text>
        </Box>

        <Box 
          position="relative" 
          zIndex={2} 
          mt={-40} 
          p={4} 
          bg="#F5F5F5" 
          rounded="lg" 
          shadow="md"
        >
          <Text fontSize="20px" fontWeight="bold" mt={4}>  
            Hiwa Boutique Hotel
            <Box ml={2} display="flex" >
              <Icon as={FaStar} color="blue" boxSize="12px" />
              <Icon as={FaStar} color="blue" boxSize="12px" />
              <Icon as={FaStar} color="blue" boxSize="12px" />
              <Icon as={FaStar} color="blue" boxSize="12px" />
              <Icon as={FaStar} color="blue" boxSize="12px" />
            </Box>
          </Text>
          
          <Text fontSize={{ base: "xs", md: "md" }} mt={{ base: 1, md: 2 }}>
          
            <ChakraLink 
            
              href="https://www.google.com/maps/place/Hiwa+Boutique+Hotel/@17.40752,78.598689,17z/data=!3m1!4b1!4m9!3m8!1s0x3bcb9eedbd5adca5:0x21032dc84d31837b!5m2!4m1!1i2!8m2!3d17.40752!4d78.598689!16s%2Fg%2F11x7r9hhfy!5m1!1e1?entry=ttu&g_ep=EgoyMDI1MDUwNS4wIKXMDSoASAFQAw%3D%3D" 
              isExternal 
              color="blue.500" 
               
            >
             
             Om Vihar Colony, Medipally, Canara Nagar, Boduppal, Hyderabad, Telangana 500098
            </ChakraLink>
          </Text>
          <Text fontSize={{ base: "xx-small", md: "sm" }} mt={{ base: 1, md: 2 }} fontWeight="bold" color="gray.500">
            Couple Friendly
          </Text>

          {/* Image positioned at the right corner */}
          <Image 
            src={hotelImage} 
            alt="Hotel Image" 
            boxSize="80px" 
            rounded="md" 
            position="absolute" 
            top="0%" 
            right="2px" // Adds right margin
            transform="translateY(-50%)" // Centers the image vertically
            zIndex={1} // This ensures the image is on top
          />
        </Box>

        <div className="flex flex-col md:flex-row gap-6 mt-3"> {/* Add top margin */}
          {/* Customer Details Section */}
          <Box bg="white" p={6} rounded="lg" shadow="md" w="full" flexBasis="60%"> {/* Adjusted width */}
            <div>
              <Text fontSize="25px" fontWeight="bold" mb={4}>Guest Details</Text>
              {/* Updated grid layout */}
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-6">
                <div className="flex flex-col">
                  <label className="font-semibold text-sm mb-1">First Name</label>
                  <Input
                    type="text"
                    name="firstName"
                    value={customerDetails.firstName}
                    onChange={handleInputChange}
                    className="w-full p-2 border rounded focus:outline-none focus:ring"
                  />
                </div>
                <div className="flex flex-col">
                  <label className="font-semibold text-sm mb-1">Last Name</label>
                  <Input
                    type="text"
                    name="lastName"
                    value={customerDetails.lastName}
                    onChange={handleInputChange}
                    className="w-full p-2 border rounded focus:outline-none focus:ring"
                  />
                </div>
                
                <div className="flex flex-col">
                  <label className="font-semibold text-sm mb-1">Phone Number</label>
                  <Input
                    type="tel"
                    name="phoneNumber"
                    value={customerDetails.phoneNumber}
                    onChange={handlePhoneChange}
                    maxLength={10}
                    inputMode="numeric"
                    className="w-full p-2 border rounded focus:outline-none focus:ring"
                  />
                </div>
                <div className="flex flex-col">
                  <label className="font-semibold text-sm mb-1">Email (optional)</label>
                  <Input
                    type="text"
                    name="email"
                    value={customerDetails.email}
                    onChange={handleInputChange}
                    className="w-full p-2 border rounded focus:outline-none focus:ring"
                  />
                </div>
                <div className="flex flex-col sm:col-span-2">
                  <label className="font-semibold text-sm mb-1">Address</label>
                  <Input
                    type="text"
                    name="address"
                    value={customerDetails.address}
                    onChange={handleInputChange}
                    className="w-full p-2 border rounded focus:outline-none focus:ring"
                  />
                </div>
                <div className="flex flex-col">
                  <label className="font-semibold text-sm mb-1">Pin Code</label>
                  <Input
                    type="text"
                    name="zipCode"
                    value={customerDetails.zipCode}
                    onChange={handleZipCodeChange}
                    maxLength={6}
                    inputMode="numeric"
                    className="w-full p-2 border rounded focus:outline-none focus:ring"
                  />
                  {isLookingUpLocation && (
                    <Text fontSize="xs" color="gray.500" mt={1}>Looking up location...</Text>
                  )}
                </div>
                <div className="flex flex-col">
                  <label className="font-semibold text-sm mb-1">City</label>
                  <Input
                    type="text"
                    name="city"
                    value={customerDetails.city}
                    onChange={handleInputChange}
                    list="city-list"
                    className="w-full p-2 border rounded focus:outline-none focus:ring"
                  />
                  <datalist id="city-list">
                    {INDIAN_CITIES.map((city) => (
                      <option key={city} value={city} />
                    ))}
                  </datalist>
                </div>
                <div className="flex flex-col">
                  <label className="font-semibold text-sm mb-1">Country</label>
                  <Input
                    type="text"
                    name="country"
                    value={customerDetails.country}
                    onChange={handleInputChange}
                    list="country-list"
                    className="w-full p-2 border rounded focus:outline-none focus:ring"
                  />
                  <datalist id="country-list">
                    {COUNTRIES.map((country) => (
                      <option key={country} value={country} />
                    ))}
                  </datalist>
                </div>
              </div>
              <div className="flex justify-between items-center mt-4">
                
                <div className="text-m">
                  Need help?
                  <Link to="/contact" className="ml-1 text-blue-500 hover:text-blue-700">
                    Contact us
                  </Link>
                </div>
              </div>
            </div>
          </Box>

          {/* Order Summary Section */}
          <Box bg="white" p={6} rounded="lg" shadow="md" w="full" flexBasis="40%"> {/* Adjusted width */}
            <h2 className="text-2xl font-bold mb-4">Order Summary</h2>
            <div className="space-y-2">
                
              <div className="flex justify-between">
                <Text fontWeight="bold">Order ID:</Text>
                <Text>{orderId || "N/A"}</Text>
              </div>
              <div className="flex justify-between">
                <Text fontWeight="bold">Check-In Date:</Text>
                <Text>{selectedRoomDetails.checkInDate || "N/A"}</Text>
              </div>
              <div className="flex justify-between">
                <Text fontWeight="bold">Check-Out Date:</Text>
                <Text>{selectedRoomDetails.checkOutDate || "N/A"}</Text>
              </div>
              <div className="flex justify-between">
                <Text fontWeight="bold">Room Type:</Text>
                <Text>{selectedRoomDetails.roomType || "N/A"}</Text>
              </div>
              <div className="flex justify-between">
                <Text fontWeight="bold">Adults:</Text>
                <Text>{selectedRoomDetails.adults || "N/A"}</Text>
              </div>
              <div className="flex justify-between">
                <Text fontWeight="bold">Kids:</Text>
                <Text>{selectedRoomDetails.kids || "N/A"}</Text>
              </div>
              <div className="flex justify-between">
                <Text fontWeight="bold">Meal Plan:</Text>
                <Text>complimentary breakfast</Text>
              </div>
              
              <div className="flex justify-between">
                 <Text fontWeight="bold">Total Amount to be Paid:</Text>
                 <Text>₹{Number(totalAmount).toLocaleString('en-IN')}</Text>
              </div>
            </div>
            {isBookingInProgress ? (
  <Center>
    <Spinner
      size="xl"
      color="blue.500"
      speed="0.65s" // Smooth rotation speed
      thickness="4px"
    />
  </Center>
) : (
  <Button
    colorScheme="gray"
    mt={4}
    onClick={handlePayAtHotel}
    className="w-full bg-gray-500 text-white py-2 px-4 rounded hover:bg-gray-600"
    isDisabled={isBookingInProgress} // Disable button during booking
  >
    Pay at Hotel
  </Button>
)}
</Box>
      </div>
      </div>
    </div>
  );
};

export default CustomerDetails;






